import { isSkorSdkMode } from "../../helper/skorSdk";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import useTranslator from "../../hooks/useTranslator";
import { FloatingSupport } from "../design";
import CreateSkorTicketModal from "./CreateSkorTicketModal";

export const SupportContext = createContext(null);

export function SupportProvider({ children }) {
  const { _t } = useTranslator();
  const auth = useContext(AuthContext);
  const location = useLocation();
  const reportContainer = useRef(null);
  const [profile, setProfile] = useState(null);
  const [reportOpen, setReportOpen] = useState(false);
  const [, setStorageVersion] = useState(0);
  useEffect(() => {
    const refresh = () => setStorageVersion((version) => version + 1);
    window.addEventListener("localStorageChange", refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener("localStorageChange", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);
  const userType = localStorage.getItem("usertype");
  const signedIn = Boolean(localStorage.getItem("token"));
  useEffect(() => setReportOpen(false), [location.key, signedIn]);
  // Reading auth context also updates this widget when logout removes storage.
  const tenant =
    profile?.tenant || (userType === "tenant" ? auth?.user : undefined);

  return (
    <SupportContext.Provider value={setProfile}>
      {children}
      {!isSkorSdkMode(location.search) && (
        <FloatingSupport
          key={`${location.key}-${signedIn}`}
          signedIn={signedIn}
          whatsappUrl={
            userType === "landlord"
              ? "https://wa.me/34617662602"
              : "https://wa.me/34911672839"
          }
          title={_t("supportMenuTitle")}
          whatsappLabel={_t("supportWhatsapp")}
          reportLabel={_t("skorTicketReportProblem")}
          closeLabel={_t("supportMenuClose")}
          onReport={() => setReportOpen(true)}
        >
          <div ref={reportContainer} className="ds-support__report">
            {signedIn && reportOpen && (
              <CreateSkorTicketModal
                container={() => reportContainer.current}
                disablePortal
                tenant={tenant}
                isGuarantor={profile?.isGuarantor || false}
                onClose={() => {
                  setReportOpen(false);
                  requestAnimationFrame(() =>
                    document.querySelector(".ds-support__trigger")?.focus()
                  );
                }}
              />
            )}
          </div>
        </FloatingSupport>
      )}
    </SupportContext.Provider>
  );
}
